import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 35% auto auto auto;
  grid-template-areas: 'titulo filtros export showModal';
  align-items: center;
  padding-bottom: 25px;

  @media (max-width: 1370px) {
    grid-template-columns: auto;
  }

  @media (max-width: 920px) {
    grid-template-areas:
      'titulo titulo titulo showModal'
      'filtros . . export';
    gap: 8px;
  }

  @media (max-width: 768px) {
    grid-template-areas:
      'titulo titulo showModal'
      'filtros filtros filtros'
      'export export export';
    gap: 8px;
    grid-template-columns: 1fr 1fr 1fr;
  }

  & > svg {
    grid-area: showModal;
    justify-self: end;
    min-width: 14px;
    min-height: 14px;
    color: ${({ theme }) => theme.colors.blue};
    cursor: pointer;
  }
`;

export const FiltersWrap = styled.div`
  display: flex;
  grid-area: filtros;
  justify-self: end;

  @media (max-width: 920px) {
    justify-self: start;
  }
`;

export const Separator = styled.div`
  height: 34px;
  width: 2px;
  border: 1px dashed rgba(0, 0, 0, 0.2);
  margin: 0 13px;
`;

export const Title = styled.div`
  grid-area: titulo;
  justify-self: start;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #0b29fb;
`;
